<div mat-dialog-title>
  <h1>Workshop history</h1>
  <h2>{{ repairableName }}</h2>
</div>
<mat-dialog-content>
  <app-workshop-job-history-list
    [data]="data"
    [dialogRef]="dialogRef"
  ></app-workshop-job-history-list>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>
